import { render, staticRenderFns } from "./manufacturersroleslist.vue?vue&type=template&id=6bc647a0&scoped=true"
import script from "./manufacturersroleslist.vue?vue&type=script&lang=js"
export * from "./manufacturersroleslist.vue?vue&type=script&lang=js"
import style0 from "./manufacturersroleslist.vue?vue&type=style&index=0&id=6bc647a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc647a0",
  null
  
)

export default component.exports